import axios from 'axios'
import { Message } from 'element-ui'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
  timeout: 10000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      Message.error(res.message || '请求失败')
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    console.error('响应错误:', error)
    Message.error(error.message || '网络错误')
    return Promise.reject(error)
  }
)

// API接口
export default {
  // 公司信息
  getCompanyInfo () {
    return service.get('/company/info')
  },

  // 产品相关
  getProducts () {
    return service.get('/products')
  },
  getProductById (id) {
    return service.get(`/products/${id}`)
  },
  getProductsByCategory (category) {
    return service.get(`/products/category/${category}`)
  },

  // 新闻相关
  getNews () {
    return service.get('/news')
  },
  getNewsById (id) {
    return service.get(`/news/${id}`)
  },
  getLatestNews (limit = 5) {
    return service.get(`/news/latest?limit=${limit}`)
  },
  getFeaturedNews () {
    return service.get('/news/featured')
  },
  getNewsByCategory (category) {
    return service.get(`/news/category/${category}`)
  },

  // 联系相关
  submitContactMessage (data) {
    return service.post('/contact/message', data)
  }
}
